<template>
  <div>
    <page-header
      :page="page"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      ref="filterRef"
      class="search-bar"
      search-icon="fa fa-sync pr-2"
      search-text="Procesar"
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="filters"
      :display-advanced="false"
      :filters="filterManagerConfig"
      @search="process"
    />
  </div>
</template>

<script>
// components libs
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

// services
import DocumentServices from '@/modules/report/document';
import ReportServices from '@/modules/report/api';
import { initFilter } from '@/services/api/proposalrequestcontract.api';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Regsitro de Contratos',
      routes: ['Inicio', 'Informes Generales', 'Regsitro de Contratos'],
    },
    academicYearsOptions: [],
    statusOptions: [],
    filters: {
      academicYear: null,
      status: null,
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-6 col-md-6',
          options: this.academicYearsOptions,
          value: this.filters.academicYear,
        },
        {
          name: 'status',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Estatus',
          clearable: true,
          class: 'col-6 col-md-6',
          options: this.statusOptions,
          value: this.filters.status,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
    this.setDefaultAcademicYear();
  },
  methods: {
    async getInitialFilters() {
      const { data } = await initFilter();
      this.academicYearsOptions = [...data.academicYears];
      this.statusOptions = [...data.proposalStatues];
    },
    setDefaultAcademicYear() {
      let defaultValue = this.academicYearsOptions.length == 1 ?
        this.academicYearsOptions[0] : null;

      if (!defaultValue) {
        defaultValue = this.academicYearsOptions.find(x => x.yearType == "CURRENT");
      }

      this.filters.academicYear = {...defaultValue};
    },
    async process() {
      if (!this.filters.academicYear?.id) return;

      const params = {
        statusId: this.filters.status?.id,
        academicYearId: this.filters.academicYear?.id,
      };

      const { data } = await ReportServices.getReport('proposalrequestcontract', params);
      await DocumentServices.Download(data);
    }
  },
};
</script>
